import { useInfiniteQuery } from 'react-query';
import { ARTICLES_CACHE_KEY } from '../../Constants';
import { fetchAnalystArticles } from '../../services/article.service';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default (analystId) => useInfiniteQuery<any[], Error>([ARTICLES_CACHE_KEY, analystId], async ({ pageParam }) => fetchAnalystArticles(analystId, pageParam), { getNextPageParam: (lastPage, pages) => pages.length + 1 });
